import { styled } from '~/styled'

export const BannerSlimContent = styled('div', {
  base: ['w-full', 'flex', 'items-center', 'gap-4']
})

BannerSlimContent.displayName = 'BannerSlimContent'
